import { computed } from 'vue'
import { useCartStore } from '~/stores/useCartStore'
import { useUserStore } from '~/stores/useUserStore'

export const useDashboardLayoutState = () => {
  const userStore = useUserStore()
  const cartStore = useCartStore()

  return {
    hasPartnerAccess: computed(() => userStore.hasPartnerAccess),
    hasStoreAccess: computed(() => userStore.hasStoreAccess),
    isInternalStaff: computed(() => userStore.isInternalStaff),
    user: computed(() => userStore.user),
    organizerAccount: computed(() => userStore.organizerAccount),
    isOrganizer: computed(() => userStore.isOrganizer),
    initialized: computed(() => userStore.initialized),
    loading: computed(() => userStore.loading),
    fetchUserAccess: userStore.fetchUserAccess,
    clearUserState: userStore.clearUserState,
    isDraftOrdersOpen: computed(() => cartStore.isDraftOrdersOpen),
    closeDraftOrdersCart: cartStore.closeDraftOrdersCart
  }
}
